// styles:
import './index.less'

// libs:
import Vue from 'vue'
import MuseUI from 'muse-ui'
import router from '../routes'

Vue.use(MuseUI)

// components:
import App from './index.vue'

// vm: root vmodel
const vm = new Vue({
  router,
  render: h => h(App),
  created () {
    console.info(document.querySelector('#app'))
    window.vm = this
  },
})
.$mount('#app')
